import React, { useId } from 'react';

// The Dr.Soft mark: a medical cross with a pulse across it, on the teal the
// rest of the app is drawn in. The same drawing as public/logo.svg, which is
// what the browser tab and the phone's home screen use - kept inline here so
// it is on screen with the first paint rather than after a request.
//
//   size   in pixels
//   plain  the cross alone, in white, for use on a teal background
const BrandLogo = ({ size = 40, plain = false, className, style }) => {
    // Two logos on one page must not share a gradient id.
    const gradient = `drsoft-${useId().replace(/:/g, '')}`;

    return (
        <svg
            className={className}
            style={style}
            width={size}
            height={size}
            viewBox="0 0 512 512"
            role="img"
            aria-label="Dr.Soft"
            focusable="false"
        >
            {!plain && (
                <>
                    <defs>
                        <linearGradient id={gradient} x1="0" y1="0" x2="1" y2="1">
                            <stop offset="0" stopColor="#05668D" />
                            <stop offset="0.55" stopColor="#028090" />
                            <stop offset="1" stopColor="#00A896" />
                        </linearGradient>
                    </defs>
                    <rect width="512" height="512" rx="116" fill={`url(#${gradient})`} />
                </>
            )}
            <rect x="194" y="102" width="124" height="308" rx="30" fill="#fff" />
            <rect x="102" y="194" width="308" height="124" rx="30" fill="#fff" />
            <polyline
                points="134,258 204,258 230,208 264,308 294,236 312,258 378,258"
                fill="none"
                stroke="#028090"
                strokeWidth="21"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const BRAND_NAME = 'Dr.Soft';

export default BrandLogo;
